module.exports = __webpack_public_path__ + "img/black.95e60015.jpg";